import {WmsItemsStatus} from "utils/WmsItemsStatus";

// A shipment created before the organization's WMS activation date must never be treated as
// WMS-handled on the picking pages, even if its line items carry a stale wmsReady=true flag.
export function isDateBeforeWmsActivation(date, currentOrganization) {
    const activationDate = currentOrganization?.wmsActivationDate;
    if (!activationDate || !date) {
        return false;
    }

    return new Date(date) < new Date(activationDate);
}

export function getLineItemCurrentShipment(lineItem) {
    const shipments = lineItem?.shipments;
    if (!shipments || shipments.length === 0) {
        return null;
    }

    return shipments[shipments.length - 1];
}

export function isLineItemWmsHandled(lineItem, currentOrganization) {
    if (!lineItem || lineItem.wmsReady !== true) {
        return false;
    }

    const currentShipment = getLineItemCurrentShipment(lineItem);

    return !isDateBeforeWmsActivation(currentShipment?.createdAt, currentOrganization);
}

export const WMS_CANCELLABLE_ITEM_STATUSES = [
    WmsItemsStatus.NEW,
    WmsItemsStatus.PENDING,
    WmsItemsStatus.PICKING,
    WmsItemsStatus.IN_TROLLEY,
    WmsItemsStatus.READY_TO_BE_SORTED,
    WmsItemsStatus.SORTED,
    WmsItemsStatus.READY_TO_BE_PACKED,
    WmsItemsStatus.PACKING, // Last status in which a wmsItem can be cancelled and handled by a runner.
    WmsItemsStatus.SHIPPED,
    WmsItemsStatus.WAITING_FOR_RECEPTION,
];

export function isWmsItemCancellable(wmsItem) {
    return !!wmsItem && WMS_CANCELLABLE_ITEM_STATUSES.includes(wmsItem.status);
}
